import { AxiosError } from 'axios';
import { get } from '@/utils';
import { resolveAgreementTypeByAppType } from '../use-agrements/actions';
import { AGREEMENT_TYPE_CONFIG, AgrementsType } from '../use-agrements/types';
import { IPublishedAgreement } from './types';

// GET api/agreements/published face potrivire exactă pe numele tipului, iar în
// nomenclator numele poate fi cel românesc (ex. „Termeni și condiții") sau cel
// englezesc din seed-ul CSV (ex. „Terms and conditions") — rezolvăm numele real
// din api/agreement-types și încercăm candidații pe rând (ambele endpoint-uri
// sunt publice, deci merg și fără token, de pe paginile de autentificare).
async function fetchPublishedByTypeName(typeName: string): Promise<unknown> {
	const res = await get(`api/agreements/published?type=${encodeURIComponent(typeName)}`);
	return res.data;
}

async function fetchPublishedAgreement(
	type: AgrementsType
): Promise<IPublishedAgreement> {
	try {
		const agreementType = await resolveAgreementTypeByAppType(type).catch(() => null);
		// candidații, în ordinea probabilității: numele din nomenclator, eticheta
		// românească din config, numele englezesc (cheia de tip e chiar acesta)
		const candidates = [
			...new Set(
				[agreementType?.name, AGREEMENT_TYPE_CONFIG[type].apiName, type].filter(
					(name): name is string => Boolean(name)
				)
			)
		];

		let payload: unknown = null;
		let lastError: unknown = null;
		for (const candidate of candidates) {
			try {
				// eslint-disable-next-line no-await-in-loop
				payload = await fetchPublishedByTypeName(candidate);
				break;
			} catch (err) {
				lastError = err;
			}
		}
		if (payload === null) throw lastError;

		const data = payload as Record<string, unknown>;

		return {
			id: Number(data?.id ?? 0),
			type,
			version: String(data?.version ?? ''),
			description: String(data?.description ?? ''),
			updatedAt: String(data?.updatedAt ?? data?.createdAt ?? '')
		};
	} catch (e) {
		const error = e as AxiosError;
		const data = error.response?.data as { error: string };
		throw new Error(data?.error || 'Nu am reușit să preluăm documentul.');
	}
}

export { fetchPublishedAgreement };
